<template>
  <div v-if="!progress">
    <v-card-title primary-title>
      <h5>{{ student.fullName() }}</h5>
      <span><h6>　さん　</h6></span>
      <span><h6>{{ '('+ student.grade().toJapanese() + '  ' + student.genderInJapanese() + ')'}}</h6></span>
    </v-card-title>
    <v-divider></v-divider>
    <div
      v-for="record in this.displayRecords.get()"
      :key="record.id">
      <div>
        <v-container>
          <v-row>
            <v-col md="2">
              <v-card-text>
                <span class="grey--text">日時</span>
              </v-card-text>
            </v-col>
            <v-col md="10">
              <v-card-text>
                {{ record.dateString() + "(" + record.lesson.schedule.day + ") /"
                  + record.lesson.schedule.start + "-" + record.lesson.schedule.end }}
              </v-card-text>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col md="2">
              <v-card-text>
                <span class="grey--text">報酬額</span>
              </v-card-text>
            </v-col>
            <v-col md="10">
              <v-card-text>
                {{ record.lesson.wage }}円
              </v-card-text>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col md="2">
              <v-card-text>
                <span class="grey--text">コメント</span>
              </v-card-text>
            </v-col>
            <v-col md="10">
              <v-card-text class="line--feed">
                {{ record.lesson.note }}
              </v-card-text>
            </v-col>
          </v-row>
        </v-container>
        <v-divider></v-divider>
      </div>
    </div>
    <MessageFromParent
      v-if="isMessage"
      :parent="parent"
      :isOpen="isMessage"
      @open="isMessage=true"
      @close="isMessage=false"
    />
    <v-card-actions>
      <v-btn
        text
        color="primary"
        @click="isMessage=true">
        家庭へメッセージを送る
      </v-btn>
    </v-card-actions>
    <v-divider></v-divider>
  </div>
</template>

<script>
import { ParentRepository } from '@/repository/ParentRepository.js'
import { firestore } from '@/repository/client/firestore.js'
import MessageFromParent from "@/components/organisms/teacher/MessageFromParent.vue"

export default {
  name: "TeacherLessonRecord",
  components: {
    "MessageFromParent": MessageFromParent
  },
  data() {
    return {
      progress: true,
      parent: null,
      displayRecords: null,
      teacher: this.$store.getters.teacher,
      isMessage: false,
      progress: true
    }
  },
  props: {
    student: Object,
    records: Object,
  },
  async created() {
    const parentRepo = new ParentRepository(firestore)
    this.parent = await parentRepo.find(this.student.parentId)
    this.displayRecords = this.records.filterByStudentId(this.student.id) 
    this.progress = false
  },
}
</script>
